import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class WashingMachineIcon extends PureComponent {
    static propTypes = {
        color: PropTypes.string,
        secondaryColor: PropTypes.string,
        size: PropTypes.number
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondaryColor: '#fff',
        size: 50
    };

    render() {
        const { color, size, secondaryColor } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 245.09 300">
                <path
                    d="M0 287.19A12.81 12.81 0 0 0 12.81 300h219.48a12.81 12.81 0 0 0 12.81-12.81V66.6H0zM245.1 12.81A12.81 12.81 0 0 0 232.29 0H12.81A12.81 12.81 0 0 0 0 12.81v44.75h245.1z"
                    fill={color}
                />
                <circle cx={169.94} cy={28.78} r={11.31} fill={secondaryColor} />
                <circle cx={211.92} cy={28.78} r={11.31} fill={secondaryColor} />
                <path
                    d="M122.55 93.2a90.1 90.1 0 1 0 90.14 90.14 90.09 90.09 0 0 0-90.14-90.14zm72.41 93.16a72.34 72.34 0 1 1-144.67 0c0-39.9 11.53-22.88 72.26 14.64s72.41-54.62 72.41-14.64zm0 0"
                    fill={secondaryColor}
                />
            </svg>
        );
    }
}

export default withTheme(WashingMachineIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/WashingMachineIcon.js